export default __webpack_public_path__ + "static/media/keyvis_text_tab@2x.af29d476.png";